import { FC, useCallback } from 'react'
import { ListRenderItemInfo, StyleProp, StyleSheet, ViewStyle } from 'react-native'
import { ColorsEnum } from '../../constants/colors'
import { IStationState, OrderStatesEnum } from '../../constants/order'
import { StationColumnIds, StationTypesEnum } from '../../constants/stations'
import { getColumnDataState } from '../../helpers/getColumnDataState'
import { useAppSelector } from '../../hooks/redux'
import { useFirebaseOrdersConnect } from '../../hooks/useFirebaseOrdersConnect'
import { stationSelectors } from '../../redux/reducers/station'
import { selectFilteredOrders } from '../../redux/reselectors/order'
import { IOrder } from '../../types/order'
import CustomerOrder from '../Order/CustomerOrder'
import Order from '../Order/Order'
import Column from '../UI/Columns/Column'

interface OrderColumnProps {
    id: StationColumnIds
    stationStates?: IStationState[]
    states?: OrderStatesEnum[]
    title: string
    width: number
    style?: StyleProp<ViewStyle>
}

const OrderColumn: FC<OrderColumnProps> = ({ id, stationStates, states, title, width, style }) => {
    const { code } = useAppSelector(stationSelectors.currentStation)!

    const memoizedOrderReselector = useCallback(
        () => selectFilteredOrders(id, code, stationStates, states),
        [id, code, stationStates, states]
    )

    const orders = useAppSelector(memoizedOrderReselector())

    useFirebaseOrdersConnect(stationStates, states)

    const isCustomerCookedColumn = id === StationColumnIds.CUSTOMER_COOKED

    const dataState = getColumnDataState(orders?.length)

    return (
        <Column
            data={orders}
            renderItem={({ item: order, index }: ListRenderItemInfo<IOrder>) =>
                code !== StationTypesEnum.CUSTOMER_STATION ? (
                    <Order
                        key={order.orderKey}
                        {...order}
                        style={index === 0 && styles.firstOrder}
                    />
                ) : (
                    <CustomerOrder
                        key={order.orderKey}
                        code={order.code}
                        textColor={isCustomerCookedColumn && '#FFFFFF'}
                        color={isCustomerCookedColumn && ColorsEnum.SUCCESS}
                    />
                )
            }
            keyExtractor={(order) => order.orderKey}
            dataState={dataState}
            title={title}
            width={width}
            style={style}
        />
    )
}

const styles = StyleSheet.create({
    firstOrder: {
        marginTop: 4,
    },
})

export default OrderColumn
